module.exports = __webpack_public_path__ + "media/images/lb/702-bd8de8f97c520668097657d15effafce.svg";